export default function install(Vue, options) {
  const checkPermission = function (roleids, userRoles, excludeAdmin = false) {
    if (!userRoles) {
      return false;
    }

    if (userRoles.indexOf(1) > -1 && !excludeAdmin) {
      return true;
    }

    if (!Array.isArray(roleids)) {
      roleids = [roleids];
    }

    for (let i = 0; i < userRoles.length; i++) {
      if (roleids.indexOf(userRoles[i]) > -1) {
        return true;
      }
    }
    return false;
  };

  /**
   * 是否有某个角色的权限
   */
  Vue.prototype.$hasPermission = (roleids, excludeAdmin = false) => {
    return checkPermission(
      roleids,
      [
        ...options.store.getters.userInfo.roleids,
        ...options.store.getters.userInfo.rules
      ],
      excludeAdmin
    );
  };

  /**
   * 是否属于某个职级
   */
  Vue.prototype.$hasStations = ($stations, excludeAdmin = false) => {
    return checkPermission(
      $stations,
      [...options.store.getters.userInfo.stations],
      excludeAdmin
    );
  };

  /**
   * 是否显示自定义检索的某个字段
   * @param {String} name
   */
  Vue.prototype.$fv = (name) => {
    return options.store.state.filterFiles.indexOf(name) > -1;
  };

  /**
   * 是否为主管
   *
   * @author Cong Peijun <congpeijun@jiemo.net>
   * @return {Boolean}
   */
  Vue.prototype.$isManager = (roleids = null) => {
    const managers = [
      18, 21, 22, 24, 25, 31, 32, 33, 36, 39, 42, 47, 48, 51, 58, 59, 70, 73, 74, 87, 142
    ];
    return checkPermission(managers, roleids || options.store.getters.userRoles);
  };

  /**
   * 判断管理员是否属于某个国家
   *
   * @author Cong Peijun <congpeijun@jiemo.net>
   * @param  {Number|Array} countries
   * @return {Boolean}
   */
  Vue.prototype.$inCountry = (countries) => {
    if (options.store.getters.userInfo.userid === 1) {
      return true;
    }
    return checkPermission(countries, options.store.getters.userInfo.countries);
  };

  /**
   * 增加 v-permission 功能
   * 参见：https://stackoverflow.com/questions/43003976/a-custom-directive-similar-to-v-if-in-vuejs
   */
  Vue.directive('permission', (el, binding, vnode) => {
    if (!Vue.prototype.$hasPermission(binding.value)) {
      // replace HTMLElement with comment node
      const comment = document.createComment(' ');
      Object.defineProperty(comment, 'setAttribute', {
        value: () => undefined,
      });
      vnode.elm = comment;
      vnode.text = ' ';
      vnode.isComment = true;
      vnode.context = undefined;
      vnode.tag = undefined;
      vnode.data.directives = undefined;

      if (vnode.componentInstance) {
        vnode.componentInstance.$el = comment;
      }

      if (el.parentNode) {
        el.parentNode.replaceChild(comment, el);
      }
    }
  });

  /**
   * 站点名称
   */
  const siteName = Vue.prototype.$siteName;

  /**
   * 是否为考培站点
   */
  Vue.prototype.isTrainingSite = siteName === 'training';

  /**
   * 是否为求职站点
   */
  Vue.prototype.isJobSite = siteName === 'job';

  /**
   * 是否为蓝火站点
   */
  Vue.prototype.isFibSite = siteName === 'fib';

  /**
   * 是否是面试系统
   */
  Vue.prototype.isInterviewSite = siteName === 'interview';
}
